<style>
	.edi-detail-bill{
		position: relative;
		width: 100%;
		height: 100%;
		overflow:hidden;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-input{
		border:solid 1px #eee;
		display: inline-block;
		width: 80px;
		margin: 0;
		padding: .5em;
		outline: none;
		font-size: 1em;
		background: none;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-span{
		box-sizing: border-box;
		border:solid 1px #eee;
		display: inline-block;
		width: 80px;
		padding: .5em;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-taxinput{
		border:solid 1px #eee;
		width: 60px;
		background-color: #f1f1f1;
		/*text-align: center;*/
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-percent{
		position: relative;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-percent:after{
		content: '%';
		position: absolute;
		top:0;
		left: -22px
	}
	.edi-detail-bill .detail-bill-sonlist li .tax-operate{

		position: relative;
		padding: 5px 12px;
		/*top: 11px;*/
		margin:0px 5px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: 80%;
	}
	 .edi-detail-bill .detail-bill-sonlist li .tax-operate-reduce{
		background-image: url('../assets/allorderbill/reduce.png');
	}
	.edi-detail-bill .detail-bill-sonlist li .tax-operate-plus{
		background-image: url('../assets/allorderbill/plus.png');
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-retrun-bgOrange {
		width: 80px;
    text-align: center;
    height: 50px;
    line-height: 50px;
		background-color: #F59A23;
	}
	.edi-detail-bill .detail-bill-footer div.detail-bill-retrun-bgOrange a {
		color: #eee;
	}

</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企订单-明细编辑"></navbar>
		<div class="common-scroll detail-scroll">
			<p class="detail-bill-status">
				{{detailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span class="state-aqua-font">待发货</span>
			</p>
			<div class="bill-all-info" v-show="billInfoShow">
				<ul class="detail-bill-info-list">
					<li class="detail-bill-fulllist">订货企业：{{detailData.restaurant_name}}</li>
					<li class="detail-bill-fulllist">
						订货机构/时间：{{detailData.from_organ_name}}
						<span class="fr">{{detailData.from_date | dateFilterYMD}}</span>
					</li>
					<li class="detail-bill-fulllist">
						收货机构/时间：{{detailData.to_organ_name}}
						<span class="fr">{{detailData.to_date | dateFilterYMD}}</span>
					</li>
					<li class="detail-bill-fulllist detail-bill-remark">整单备注：{{detailData.remark}}</li>
					<li class="detail-bill-fulllist detail-bill-remark">
						发货描述：
						<input v-model="detailData.delivery_describe" type="text" maxlength="50">
					</li>
					<li class="detail-bill-fulllist detail-bill-remark">
						快递服务商：
						<input v-model="detailData.express_provider" type="text" maxlength="50">
					</li>
					<li class="detail-bill-fulllist detail-bill-remark">
						快递单号：
						<input v-model="detailData.express_no" type="text" maxlength="50">
					</li>
				</ul>
			</div>
			<div class="detail-bill-search-wrapper">
				<input class="detail-search-input" placeholder="请输入要搜索的品项名称" v-model="searchWord">
			</div>
			<div class="detail-bill-wrapper">
				<h4 class="detail-bill-address aqua-font">
					<span class="list-btn fl">
						<img src="../assets/list_open.png" alt="">
					</span>
					明细条目({{detailsFilter.length}})
					<a class="detail-bill-edit state-aqua-font" @click="cancel">取消</a>
				</h4>
				<ul class="detail-bill-list">
					<li v-for="(detail, index) in detailsFilter">
						<ul class="detail-bill-sonlist">
							<li class="detail-bill-fulllist detail-bill-list-title">
								{{detail.goods_name}}<span v-if="(detail.goods_assist_unit ? showAssistUnitFlag: true) || isZ5">({{detail.goods_unit}})</span> {{detail.gift_flag ? '【赠品】' : ''}}
								<span class="fr silvery-font" v-if="detailData.billBusTypeID !== '0450_0030_0600_3'">{{detail.inStoreName}}</span>
								<span class="fr silvery-font" v-else>{{detail.inStoreName}}/{{detail.shopStoreName}}</span>
							</li>
							<li v-if="(detail.goods_assist_unit ? showAssistUnitFlag: true) || isZ5">订货数量：{{detail.goods_num | numFixed(numScale)}}</li>
							<li v-if="detail.bill_gross_weight">毛重：{{detail.bill_gross_weight | numFixed(4)}}</li>
							<li v-if="(detail.goods_assist_unit ? showAssistUnitFlag: true) || isZ5">发货数量：
								<input type="text" class="detail-bill-edit-input" v-model="detail.goods_num_send" @input="goodsNumCount(detail)" @blur="goodsNumCountFixed(detail)" v-if="detailData.can_change_cnt"/>
								<input type="text" class="detail-bill-edit-input" v-model="detail.goods_num_send" readonly onfocus="this.blur()" v-else/>
							</li>
							<li v-if="detailData.partial_delivery_flag === 1">已发数量：{{detail.goods_num_sended | numFixed(numScale)}}</li>
              <li><span v-show="!detailData.hiddenTax">含税</span>单价：
								<input type="text" class="detail-bill-edit-input" v-model="detail.goods_price_send" v-if="detailData.can_change_price && !detail.gift_flag" @input="sendPriceCount(detail)" @blur="sendPriceCountFixed(detail)"/>
								<input type="text" class="detail-bill-edit-input" v-model="detail.goods_price_send" readonly onfocus="this.blur()" v-else/>
							</li>
							<li v-if="detailData.partial_delivery_flag === 1">待发数量：{{detail.goods_num_wait_send | numFixed(numScale)}}</li>
							<li v-show="!detailData.hiddenTax">价税合计：
								<input type="text" class="detail-bill-edit-input" v-model="detail.sub_total_send" @input="subSendCount(detail)" @blur="subSendCountFixed(detail)" v-if="detailData.can_change_price && !detail.gift_flag"/>
								<input type="text" class="detail-bill-edit-input" v-model="detail.sub_total_send" readonly onfocus="this.blur()" v-else/>
							</li>
							<li v-show="!detailData.hiddenTax">税率
								<span style="position: relative; left: -10px" v-if="detailData.can_change_price && !detail.gift_flag && detailData.canChangeTaxes">
									<span class="tax-operate tax-operate-reduce" @click="reduce(detail)"></span>
									<input type="text" class="detail-bill-edit-taxinput" v-model="detail.goods_cess" readonly />
									<span class="detail-bill-edit-percent"></span>
									<span class="tax-operate tax-operate-plus" @click="plus(detail)"></span>
								</span>
								<span style="position: relative;" v-else>
									<input type="text" class="detail-bill-edit-taxinput" v-model="detail.goods_cess" readonly />
								</span>
							</li>
							<div v-show="detail.goods_assist_unit!=null">
								<li>
									<div style="height: 30px;line-height: 30px;">辅助单位：{{detail.goods_assist_unit}}</div>
								</li>
								<li>订货辅助数量：
									<input type="text" class="detail-bill-edit-input" v-model="detail.goods_assist_num" readonly onfocus="this.blur()"/>
								</li>
								<li>发货辅助数量：
									<input type="text" class="detail-bill-edit-input" v-model="detail.goods_assist_num_send" @blur="goodsAssistCountFixed(detail)" v-if="assistUnitHandleFlag"/>
									<input type="text" class="detail-bill-edit-input" v-model="detail.goods_assist_num_send" readonly onfocus="this.blur()" v-else/>
								</li>
								<li>实收辅助数量：
									<input type="text" class="detail-bill-edit-input" v-model="detail.goods_assist_num_recipient" readonly onfocus="this.blur()"/>
								</li>
							</div>
							<!-- <li></li> -->
							<li class="detail-bill-fulllist" v-if="!(detail.remark == null || detail.remark == '' )">备注：{{detail.remark}}</li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="detail-bill-search-empty" v-if="!detailsFilter.length">
				<div class="middle-empty"></div>
				<p>未找到相关品项</p>
			</div>
		</div>
		<div class="detail-bill-footer">
			<div class="detail-else-info" v-show="show">
				<p>配送至：{{detailData.to_organ_name}}</p>
				<p class="detail-else-info-list">
					<span class="detail-else-info-list-span">订货金额：{{detailData.sum_money | numFixed(numScale)}}元</span>
					<span class="detail-else-info-list-span">订货数量：{{sumGoodsNum | numFixed(numScale)}}</span>
				</p>
				<p class="detail-else-info-list">	<span class="detail-else-info-list-span" v-if="!isZ5">订货辅助数量：{{sumGoodsAssistNum | numFixed(numScale)}}</span></p>
				<p class="detail-else-info-list">	<span class="detail-else-info-list-span" v-if="!isZ5">发货辅助数量：{{sumGoodsAssistNumSend | numFixed(numScale)}}</span></p>
				<p class="detail-else-info-list">	<span class="detail-else-info-list-span" v-if="!isZ5">收货辅助数量：{{sumGoodsAssistNumRecipient | numFixed(numScale)}}</span></p>
			</div>
			<div class="detail-bill-info">
				<span class="detail-bill-total-btn" @click="infoExchange">合计</span>
			</div>
			<div class="detail-bill-agreen f-right">
				<a @click="save">保存</a>
			</div>
			<!-- 不上传附件不能点击发货按钮 -->
			<div v-if="detailData.bill_state == 11" class="detail-bill-return f-right" :class="{'bgGrey': ((uploadImgList.length === 0 && uploadDeliverFlag) || (expressNoDeliveryFlag && detailData.express_no === ''))}">
				<a @click="askSend(false)">发货</a>
			</div>
			<div v-if="detailData.partial_delivery_flag === 1" class="detail-bill-retrun-bgOrange f-right">
				<a @click="askSend(true)">分批发货</a>
			</div>
		</div>
		<div class="tips-mask-t" v-show="tipsTwoShow" @click.stop="hideRuturnConfirm">
			<div class="tips-wrapper" :class="{'tips-start':tipsTwoShow,'tips-end':!tipsTwoShow}">
				<div class="tips-font">
					<p>{{elseTipsFont}}</p>
				</div>
				<div class="tips-btns">
					<a class="tips-two-btn tips-marbot red-font" @click.stop="saveReturn">{{elseBtnFont[0]}}</a>
					<a class="tips-two-btn tips-marbot" @click.stop="quitRuturn">{{elseBtnFont[1]}}</a>
					<a class="tips-two-btn" @click.stop="hideRuturnConfirm">{{elseBtnFont[2]}}</a>
				</div>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFontWaring="tipsWaring" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>
<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			sendStatus: false,
			skipRoute: false,
			show: false,
			tips: false,
			tipsWaring: false,
			tipsauto: false,
			sec: 1500,
			msg: [],
			btnNum: 2,
			tipsFont: '',
			loading: true,
			details: [],
			detailData: {},
			billOtherData: null,
			index: 0,
			cess_data: [0, 3, 6, 8, 13, 17],
			unitPrice: [],
			queryData: this.$route.query,
			nanArr: [],
			allInfo: '',
			numScale: 2,
			// numPatrn: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/,
			numPatrn: /^(([0-9]+[\.]?[0-9]+)|[0-9])$/,
			deviceHeight: this.$root.deviceHeight,
			elseTipsFont: '当前单据明细尚未保存',
			elseBtnFont: ['保存并返回', '放弃并返回', '取消'],
			tipsTwoShow: false,
			editStatus: true,
			store: GlobalStore,
			goodsTotalInfo: {},
			billInfoShow: false,
			sumGoodsNum: 0,
			sumGoodsMoney: 0,
			searchWord: '',
			isZ5: false,
			assistUnitHandleFlag: false,
			assistUnitSynchroFlag: true,
			uploadDeliverFlag: false, // 不上传附件不允许发单。undefined: 没有此功能；true: 不上传附件不允许发单；false: 不上传附件允许发单
			expressNoDeliveryFlag: false,
			uploadImgList: [],
			showAssistUnitFlag: true,
			moreOrderFlag: true,
			deliveryArrivalTimeDescFlag: false
		}
	},
	components: {
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	beforeRouteLeave (to, from, next) {
		if (this.skipRoute) {
			next()
			return
		}
		if (this.editStatus) {
			next(false)
			this.tipsTwoShow = true
		} else {
			next()
		}
	},
	created () {
		this.goodsTotalInfo = this.store.goodsTotalInfo
		window.console.log(this.goodsTotalInfo)
		this.loading = true
		this.searchWord = this.queryData.searchWord
		var filterData = {
			bill_id: this.queryData.bill_id
		}
		this.$http.post('/cldEdi/business/billWithDetail', filterData).then(response => {
			this.billOtherData = response.body.otherdata
			const forceUploadPermitFlag = (!response.body.otherdata || response.body.otherdata.forceUploadPermitFlag === null) ? false : response.body.otherdata.forceUploadPermitFlag
			const d = this.queryData.send_date
			this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
			this.loading = false
			if (!this.isZ5 && forceUploadPermitFlag === true) {
				this.$fxToast.warning('请上传供货商证照信息！')
				this.$router.replace({path: '/main/my'})
			}

			this.detailData = response.body.data
			this.detailData.send_date = d ? this.$fxUtils.setDateTime(this.$fxUtils.newDate(d)) : null
			this.numScale = this.detailData.number_scale || 2
			this.details = response.body.data.details
			this.assistUnitHandleFlag = response.body.otherdata == null ? false : response.body.otherdata.assistUnitHandleFlag
			this.assistUnitSynchroFlag = response.body.otherdata == null ? true : response.body.otherdata.assistUnitSynchroFlag
			this.showAssistUnitFlag = response.body.otherdata == null ? true : response.body.otherdata.showAssistUnitFlag
			this.uploadDeliverFlag = response.body.otherdata == null ? undefined : response.body.otherdata.uploadDeliverFlag
			this.expressNoDeliveryFlag = response.body.otherdata == null ? undefined : response.body.otherdata.expressNoDeliveryFlag
			this.moreOrderFlag = response.body.otherdata == null ? undefined : response.body.otherdata.moreOrderFlag
			this.deliveryArrivalTimeDescFlag = response.body.otherdata == null ? undefined : response.body.otherdata.deliveryArrivalTimeDescFlag
			this.trans_bill_id = this.detailData.trans_bill_id
			this.details.forEach(e => {
				e.sub_total_send_initData = e.sub_total_send
				if (this.detailData.partial_delivery_flag === 1) {
					if (e.goods_num > e.goods_num_sended) {
						e.goods_num_wait_send = e.goods_num - e.goods_num_sended
						e.goods_num_send = e.goods_num - e.goods_num_sended
					} else {
						e.goods_num_wait_send = 0
						e.goods_num_send = 1
					}
				} else {
					e.goods_num_wait_send = 0
				}
			})
			// 获取附件列表
			if (!this.isZ5 && this.uploadDeliverFlag !== undefined) {
				this.getUploadPost()
			}
			this.dataHandle()
		})
	},
	methods: {
		// 获取附件列表
		getUploadPost () {
			const params = {
				id: this.isZ5 ? this.queryData.bill_id : this.trans_bill_id
			}
			this.$http.post('/cldEdi/business/bill/showEnclosure', params).then((response) => {
				var data = response.body
				if (data.result) {
					this.uploadImgList = data.data
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		toFixed (value) {
			var val = Number(value)
			return parseFloat(val.toFixed(this.numScale))
		},
		saveReturn () {
			this.tipsTwoShow = false
			this.loading = true
			var details = this.detailData.details
			for (var i = 0; i < details.length; i++) {
				if (isNaN(details[i].sub_total_send) || isNaN(details[i].goods_num_send) || isNaN(details[i].goods_price_send)) {
					this.nanArr.push(details[i].sub_total_send) || this.nanArr.push(details[i].goods_num_send) || this.nanArr.push(details[i].goods_price_send)
				}
			}
			// window.console.log(this.nanArr)
			if (this.nanArr.length !== 0) {
				this.loading = false
				this.autoTips('所填项必须为数字')
				return false
			}
			this.editStatus = false
			this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.$router.replace({path: '/all-order-bill', query: this.goodsTotalInfo.queryData})
				} else {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		quitRuturn () {
			this.editStatus = false
			this.tipsTwoShow = false
			this.$router.replace({path: '/all-order-bill', query: this.goodsTotalInfo.queryData})
		},
		hideRuturnConfirm () {
			this.editStatus = true
			var route = this.$route
			var path = route.path
			var query = route.query
			this.tipsTwoShow = false
			this.skipRoute = true
			this.$router.replace('/all-order-bill')
			this.$router.push({
				path: path,
				query: query
			})
			this.skipRoute = false
		},
		infoExchange () {
			this.show = !this.show
		},
		dataHandle () {
			var data = this.details
			var arr = this.detailData.goods_cess_array.split(',')
			for (var i = 0; i < data.length; i++) {
				data[i].goods_cess_array = arr
				data[i].goods_price_send_notax = data[i].goods_price_send / (1 + data[i].goods_cess / 100)
				var index = data[i].goods_cess_array.indexOf(data[i].goods_cess + '')
				data[i].goods_cess_index = index
			}
			// window.console.log(data)
		},
		showAll (val) {
			clearTimeout(timer)
			this.allInfo = val
			var self = this
			self.show = true
			var timer = setTimeout(() => {
				self.show = false
			}, 5000)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			if (this.tipsWaring) {
				this.tipsWaring = false
				this.btnNum = 2
				return false
			}
			if (this.msg[1]) {
				this.send()
				return false
			}
		},
		compare (a, b, p, detailData) {
			var price, x
			if (b !== a) {
				x = a
			}
			switch (x) {
			case 1:
				x = 1.00
				break
			case 2:
				x = 1.03
				break
			case 3:
				x = 1.06
				break
			case 4:
				x = 1.08
				break
			case 5:
				x = 1.13
				break
			case 6:
				x = 1.17
				break
			}
			price = p / x
			this.interCount(price, detailData)
		},
		interCount (val, detailData) {
			// 变更税率计算含税单价和价税合计
			if (this.unitPrice.indexOf(val) === -1) {
				this.unitPrice.push(val)
			}
			var rate = null
			switch (detailData.goods_cess) {
			case 1:
				rate = 1.00
				break
			case 2:
				rate = 1.03
				break
			case 3:
				rate = 1.06
				break
			case 4:
				rate = 1.08
				break
			case 5:
				rate = 1.13
				break
			case 6:
				rate = 1.17
				break
			}
			// window.console.log(this.unitPrice)
			detailData.goods_price_send = this.unitPrice[0] * rate
			detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
			detailData.sub_total_send = detailData.goods_price_send * detailData.goods_num_send
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
		},
		goodsNumCount (detailData) {
			// 变更发货数量计算价税合计
			this.nanArr = []
			var num = detailData.goods_num_send * detailData.goods_price_send
			detailData.sub_total_send = this.toFixed(num)
			// 计算辅助数量
			if (this.assistUnitSynchroFlag === 1) {
				detailData.goods_assist_num_send = this.toFixed(detailData.goods_num_send * detailData.BusUnitRatio / detailData.assistUnitRatio)
			}
		},
		goodsNumCountFixed (detailData) {
			if (!this.moreOrderFlag && detailData.goods_num_send > detailData.goods_num) {
				this.autoTips('发货数量不允许大于订货数量')
				detailData.goods_num_send = detailData.goods_num
				detailData.sub_total_send = detailData.sub_total_send_initData
				return false
			}
			if (!(this.numPatrn.test(detailData.goods_num_send))) {
				this.autoTips('发货数量只能是正数')
				detailData.goods_num_send = detailData.goods_num
				detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				return false
			}
			if (detailData.goods_num_send > 100000) {
				this.autoTips('发货数量有效值范围：0~99999')
				detailData.goods_num_send = detailData.goods_num
				detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				return false
			}
			detailData.goods_num_send = this.toFixed(parseFloat(detailData.goods_num_send))
			detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
		},
		goodsAssistCountFixed (detailData) {
			if (!(this.numPatrn.test(detailData.goods_assist_num_send))) {
				this.autoTips('发货辅助数量只能是正数')
				detailData.goods_assist_num_send = 0
				return false
			}
			detailData.goods_assist_num_send = this.toFixed(parseFloat(detailData.goods_assist_num_send))
			if (this.assistUnitSynchroFlag === 2) { // 辅助数量反算数量
				detailData.goods_num_send = this.toFixed(detailData.goods_assist_num_send * detailData.assistUnitRatio / detailData.BusUnitRatio)
			}
		},
		sendPriceCount (detailData) {
			// 变更含税价格计算不含税单价和价税合计
			this.nanArr = []
			this.unitPrice = []
			detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send.toFixed(this.numScale))
		},
		sendPriceCountFixed (detailData) {
			// detailData.goods_price_send = parseFloat(this.detailData.goods_price_send)
			// detailData.goods_price_send = detailData.goods_price_send.toFixed(2)
			if (!(this.numPatrn.test(detailData.goods_price_send))) {
				this.autoTips('含税单价只能是正数')
				detailData.goods_price_send = 0.00
				detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				return false
			}
			if (detailData.goods_price_send > 100000) {
				this.autoTips('含税单价有效值范围：0~99999')
				detailData.goods_price_send = 0.00
				detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				return false
			}
			detailData.goods_price_send = this.toFixed(parseFloat(detailData.goods_price_send))
			detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
		},
		subSendCount (detailData) {
			// 变更价税合计计算含税单价和不含税单价
			this.nanArr = []
			this.unitPrice = []
			detailData.goods_price_send = detailData.sub_total_send / detailData.goods_num_send
			detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
		},
		subSendCountFixed (detailData) {
			if (!(this.numPatrn.test(detailData.sub_total_send))) {
				this.autoTips('价税合计只能是正数')
				detailData.sub_total_send = 0.00
				detailData.goods_price_send = 0.00
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
				return false
			}
			if (detailData.sub_total_send > 100000) {
				this.autoTips('价税合计有效值范围：0~99999')
				detailData.sub_total_send = 0.00
				detailData.goods_price_send = 0.00
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
				return false
			}
			detailData.sub_total_send = this.toFixed(parseFloat(detailData.sub_total_send))
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
		},
		plus (detailData) {
			// 不含税单价的计算
			// detail.goods_price_send
			// window.console.log(detailData.goods_cess)
			var noTaxPrice = detailData.goods_price_send / (1 + detailData.goods_cess / 100)
			// window.console.log(noTaxPrice)
			// window.console.log(detailData.goods_cess + ',' + detailData.goods_price_send)
			var goodsCessArray = detailData.goods_cess_array
			if (detailData.goods_cess_index < goodsCessArray.length - 1) {
				detailData.goods_cess_index++
			} else {
				detailData.goods_cess_index = goodsCessArray.length - 1
			}
			detailData.goods_cess = detailData.goods_cess_array[detailData.goods_cess_index]
			// var endNoTaxPrice = detailData.goods_price_send / (1 + detailData.goods_cess / 100)
			// window.console.log(endNoTaxPrice)
			detailData.goods_price_send = noTaxPrice * (1 + detailData.goods_cess / 100)
			detailData.sub_total_send = detailData.goods_price_send * detailData.goods_num_send
			detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
		},
		reduce (detailData) {
			var noTaxPrice = detailData.goods_price_send / (1 + detailData.goods_cess / 100)
			if (detailData.goods_cess_index > 0) {
				detailData.goods_cess_index --
			} else {
				detailData.goods_cess_index = 0
			}
			detailData.goods_cess = detailData.goods_cess_array[detailData.goods_cess_index]
			detailData.goods_price_send = noTaxPrice * (1 + detailData.goods_cess / 100)
			detailData.sub_total_send = detailData.goods_price_send * detailData.goods_num_send
			detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
			detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
		},
		save () {
			this.loading = true
			var details = this.detailData.details
			for (var i = 0; i < details.length; i++) {
				if (isNaN(details[i].sub_total_send) || isNaN(details[i].goods_num_send) || isNaN(details[i].goods_price_send)) {
					this.nanArr.push(details[i].sub_total_send) || this.nanArr.push(details[i].goods_num_send) || this.nanArr.push(details[i].goods_price_send)
				}
			}
			// window.console.log(this.nanArr)
			if (this.nanArr.length !== 0) {
				this.loading = false
				this.autoTips('所填项必须为数字')
				return false
			}
			this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.editStatus = false
				this.loading = false
				var data = response.body
				if (data.result) {
					this.$router.replace({path: '/detail-bill', query: { bill_id: this.queryData.bill_id }})
					// this.$router.go(-1)
				} else {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		send () {
			this.loading = true
			var details = this.detailData.details
			for (var i = 0; i < details.length; i++) {
				if (isNaN(details[i].sub_total_send) || isNaN(details[i].goods_num_send) || isNaN(details[i].goods_price_send)) {
					this.nanArr.push(details[i].sub_total_send) || this.nanArr.push(details[i].goods_num_send) || this.nanArr.push(details[i].goods_price_send)
				}
			}
			// window.console.log(this.nanArr)
			if (this.nanArr.length !== 0) {
				this.loading = false
				this.autoTips('请输入数字')
				return false
			}
			var goodsNumSendZero = 0
			this.details.forEach(e => {
				if (e.goods_num_send !== 0) {
					goodsNumSendZero++
				}
			})
			if (goodsNumSendZero === 0 && this.detailData.partial_delivery_flag === 1) {
				this.autoTips('整单数量为0的单据不允许发货!')
				this.loading = false
				return false
			}
			this.detailData.bill_state = 12
			this.detailData.addBatch_flag = this.sendStatus
			this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.loading = false
				this.editStatus = false
				var data = response.body
				if (data.result) {
					// 需求:明细编辑页面点击发货成功后 跳转明细页面 2017/6/30 shang
					this.$router.push({path: '/detail-bill', query: { bill_id: this.queryData.bill_id, msg: data.message }})
				} else {
					this.detailData.bill_state = 11
					let str = ''
					if (data.otherdata) {
						if (data.otherdata.otherData[0].allZeroFlag === true) {
							this.autoTips(data.otherdata.otherData[0].msg)
						} else {
							data.otherdata.otherData.forEach(val => {
								if (!val.success) {
									str += val.itemId + ','
								}
							})
							str = '以下品项的入库量不允许超过订单量的一定范围:\n' + str.substr(0, str.length - 1)
							this.tipsFont = str
							this.btnNum = 1
							this.tipsWaring = true
							this.tips = true
						}
					} else {
						this.autoTips(data.message)
					}
					this.editStatus = true
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		cancel () {
			this.editStatus = false
			this.$router.replace({path: '/detail-bill', query: { bill_id: this.queryData.bill_id }})
		},
		askSend (status) {
			/* 如果不上传附件，不能发货。 系统参数为true时继续判断是否已上传*/
			if (this.uploadDeliverFlag !== undefined) {
				if (this.uploadDeliverFlag && this.uploadImgList.length === 0) {
					this.autoTips('不上传附件不允许发货')
					return
				}
			}
			if (this.expressNoDeliveryFlag !== undefined && !this.isZ5 && !status) { // 分批发货不考虑 不填写快递单号不允许发货
				if (this.expressNoDeliveryFlag) {
					if (this.billOtherData.isMiCunBanFan && (this.detailData.express_provider === '' || this.detailData.express_no === '')) {
						this.autoTips('不填写快递服务商、快递单号不允许发货')
						return
					} else if (!this.billOtherData.isMiCunBanFan && this.detailData.express_no === '') {
						this.autoTips('不填写快递单号不允许发货')
						return
					}
				}
			}
			if (this.deliveryArrivalTimeDescFlag !== undefined && !this.isZ5) {
				if (this.deliveryArrivalTimeDescFlag && this.detailData.delivery_describe === '') {
					this.autoTips('请填写发货描述')
					return
				}
			}
			if (status === true) {
				this.sendStatus = true
			} else {
				this.sendStatus = false
			}
			this.tips = true
			this.tipsFont = '是否保存并发货？'
		},
		readonlyIOS () {
			console.log(this)
			this.$el.blur()
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if ((typeof val === 'string' && val !== '') || typeof val === 'number') {
			// 	if (scale) {
			// 		return parseFloat(val).toFixed(scale)
			// 	} else {
			// 		return val
			// 	}
			// } else {
			return val
			// }
		}
	},
	computed: {
		detailsFilter () {
			if (this.searchWord.trim()) {
				return this.details.filter(detail => detail.goods_name.indexOf(this.searchWord.trim()) >= 0)
			} else {
				return this.details
			}
		},
		// totalMath () {
		// 	this.detailData.sum_money_send = 0
		// 	var details = this.detailData.details
		// 	// 报红bug:computed实时计算的时候 还没有从后台返回detailData数据 此处进行一次判断 2017/6/30 shang
		// 	if (details) {
		// 		for (var i = 0; i < details.length; i++) {
		// 			this.detailData.sum_money_send += parseFloat(details[i].sub_total_send)
		// 		}
		// 	}
		// 	this.detailData.sum_money_send = this.detailData.sum_money_send.toFixed(2)
		// 	return this.detailData.sum_money_send
		// },
		sumGoodsNum () {
			let sumGoodsNum = 0
			let details = this.details
			if (details) {
				for (let i = 0; i < details.length; i++) {
					sumGoodsNum += details[i].goods_num
				}
			}
			return sumGoodsNum
		},
		sumGoodsAssistNum () {
			let sumGoodsAssistNum = 0
			let details = this.details
			if (details) {
				for (let i = 0; i < details.length; i++) {
					sumGoodsAssistNum += details[i].goods_assist_num
				}
			}
			return sumGoodsAssistNum
		},
		sumGoodsAssistNumSend () {
			let sumGoodsAssistNumSend = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsAssistNumSend += this.details[i].goods_assist_num_send
				}
			}
			return sumGoodsAssistNumSend
		},
		sumGoodsAssistNumRecipient () {
			let sumGoodsAssistNumRecipient = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsAssistNumRecipient += this.details[i].goods_assist_num_recipient
				}
			}
			return sumGoodsAssistNumRecipient
		}
	}
}
</script>



// WEBPACK FOOTER //
// DetailBillFirstEdit.vue?3ef0f53d